export const accountingNavigationEn = {
  "cowork.accountingNav.accounting": "Accounting",
  "cowork.accountingNav.personnel": "Personnel",
  "cowork.accountingNav.agentWork": "Agent work",
  "cowork.accountingNav.workingPapers": "Generated reports",
  "cowork.accountingNav.generatedOutputs": "Generated outputs",
  "cowork.accountingNav.postedBooks": "Posted books",
  "cowork.accountingNav.reportsHint": "Account balances come from posted journals. Generated reports and dashboards are separate outputs; their approval does not post an entry.",
  "cowork.accountingNav.agentHint": "Manage conversations, review agent jobs, and open generated reports and dashboards. Posting remains an explicit accounting action.",
  "cowork.accountingNav.settingsHint": "Configure company accounting, manage access and connect supporting tools.",
  "cowork.accountingNav.personnelHint": "Manage company personnel records. Contracts, leave and payroll calculations will be added in a later release.",
  "cowork.accountingNav.paperHint": "Saved agent outputs. Review or approval here does not change the posted books.",
  "cowork.accountingNav.companySettings": "Company accounting settings",
  "cowork.accountingNav.backToList": "Back to list",
  "cowork.accountingNav.backToSettings": "Back to Settings",
  "cowork.accountingNav.dateFormat": "dd/mm/yyyy",
  "cowork.accountingNav.details": "Details",
  "cowork.accountingNav.total": "Total",
  "cowork.accountingNav.journalUnavailable": "This journal is not available in the selected period.",
} as const

export const accountingNavigationEt: Record<keyof typeof accountingNavigationEn, string> = {
  "cowork.accountingNav.accounting": "Raamatupidamine",
  "cowork.accountingNav.personnel": "Personal",
  "cowork.accountingNav.agentWork": "Agentide töö",
  "cowork.accountingNav.workingPapers": "Loodud aruanded",
  "cowork.accountingNav.generatedOutputs": "Loodud väljundid",
  "cowork.accountingNav.postedBooks": "Kinnitatud kanded",
  "cowork.accountingNav.reportsHint": "Kontode saldod põhinevad kinnitatud kannetel. Loodud aruanded ja töölauad on eraldi väljundid; nende heakskiitmine ei kinnita kannet.",
  "cowork.accountingNav.agentHint": "Halda vestlusi, vaata üle agentide töö ning ava loodud aruanded ja töölauad. Kande kinnitamine on eraldi raamatupidamistoiming.",
  "cowork.accountingNav.settingsHint": "Seadista ettevõtte raamatupidamine, halda juurdepääsu ja ühenda tööriistad.",
  "cowork.accountingNav.personnelHint": "Halda ettevõtte personaliandmeid. Lepingud, puhkused ja palgaarvestus lisanduvad hilisemas versioonis.",
  "cowork.accountingNav.paperHint": "Agentide salvestatud väljundid. Ülevaatamine või heakskiitmine siin ei muuda kinnitatud kandeid.",
  "cowork.accountingNav.companySettings": "Ettevõtte raamatupidamise seaded",
  "cowork.accountingNav.backToList": "Tagasi loendisse",
  "cowork.accountingNav.backToSettings": "Tagasi seadete juurde",
  "cowork.accountingNav.dateFormat": "dd/mm/yyyy",
  "cowork.accountingNav.details": "Üksikasjad",
  "cowork.accountingNav.total": "Kokku",
  "cowork.accountingNav.journalUnavailable": "See kanne ei ole valitud perioodis saadaval.",
}

export const accountingNavigationRu: Record<keyof typeof accountingNavigationEn, string> = {
  "cowork.accountingNav.accounting": "Бухгалтерия",
  "cowork.accountingNav.personnel": "Персонал",
  "cowork.accountingNav.agentWork": "Работа агентов",
  "cowork.accountingNav.workingPapers": "Сгенерированные отчёты",
  "cowork.accountingNav.generatedOutputs": "Созданные результаты",
  "cowork.accountingNav.postedBooks": "Проведённые записи",
  "cowork.accountingNav.reportsHint": "Остатки по счетам рассчитываются по проведённым записям. Сгенерированные отчёты и панели — отдельные результаты; их одобрение не проводит запись.",
  "cowork.accountingNav.agentHint": "Управляйте разговорами, проверяйте задания агентов и открывайте созданные отчёты и панели показателей. Проведение остаётся отдельным бухгалтерским действием.",
  "cowork.accountingNav.settingsHint": "Настройте бухгалтерский учёт компании, управляйте доступом и подключайте инструменты.",
  "cowork.accountingNav.personnelHint": "Управляйте данными персонала компании. Договоры, отпуска и расчёт зарплаты появятся в следующей версии.",
  "cowork.accountingNav.paperHint": "Сохранённые результаты работы агентов. Проверка или одобрение здесь не изменяет проведённые записи.",
  "cowork.accountingNav.companySettings": "Настройки бухгалтерского учёта компании",
  "cowork.accountingNav.backToList": "Назад к списку",
  "cowork.accountingNav.backToSettings": "Назад к настройкам",
  "cowork.accountingNav.dateFormat": "dd/mm/yyyy",
  "cowork.accountingNav.details": "Подробности",
  "cowork.accountingNav.total": "Итого",
  "cowork.accountingNav.journalUnavailable": "Эта запись недоступна в выбранном периоде.",
}
